import {CanMatchFn} from '@angular/router';

const allowedFixtureStates = new Set([
  'additional-properties',
  'list-load-failure',
  'series-partial-failure',
  'scheduled-engagements',
  'scheduled-engagements-ended',
]);

const allowedFixturePaths = new Set([
  '/webinars',
]);

export function isWebinarsVisualFixtureUrl(href: string): boolean {
  const url = new URL(href);
  const isLocalHost = ['localhost', '127.0.0.1', '[::1]', '::1'].includes(url.hostname);
  const fixtureState = url.searchParams.get('webinarsVisualFixture') || '';

  return isLocalHost && allowedFixturePaths.has(url.pathname) && allowedFixtureStates.has(fixtureState);
}

export const webinarsVisualFixtureCanMatch: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location) return false;

  return isWebinarsVisualFixtureUrl(window.location.href);
};
